<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                </div>
                <div class="container shape-container d-flex">
                    <h1 class="mb-0">LA DÉCLARATION  DE CRÉATION DE L'ASSOCIATION</h1>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

    <div class="row justify-content-center">
        <div class="col-lg-6">
            <!-- Tabs with icons -->
            <tabs fill class="flex-column flex-md-row">
                <card shadow slot-scope="{activeTabIndex}">
                    <tab-pane key="tab1">
                        <template slot="title">
                            <i class="ni ni-bulb-61 mr-2"></i>Déclaration
                        </template>

                        <p class="description">	•	Vu la loi N° 04-038 du 05 Aout 2004 portant création d’association en République du Mali</p>
                        <p class="description">	•	Vu  la volonté des membres de l'<b>Association pour le Réarmement Moral et Spirituel / Initiatives et Changement International « Dambé ni Nieta »</b></p>
                        <p class="description"> •	Nous, hommes et femmes, citoyens maliens, engagés à vivre les préceptes d’honnêteté, de pureté, de désintéressement et d’amour, avons décidé de créer une association dénommée <b>Association pour le Réarmement Moral et Spirituel / Initiatives et Changement International « Dambé ni Nieta »</b></p>
                    </tab-pane>

                    <tab-pane key="tab2">
                        <template slot="title">
                            <i class="ni ni-world-2 mr-2"></i>Buts
                        </template>

                        <p class="description">	•	de former des hommes et des femmes aptes à promouvoir le Réarmement moral au Mali, c’est-à-dire à établir l’entente et l’unité entre les personnes pour le perfectionnement et le développement du sens moral inné dans la conscience de chacun ;</p>
                        <p class="description">	•	de prévenir et résoudre les conflits entre personnes et groupes d’origines et de cultures différentes ;</p>
                        <p class="description">	•	de soutenir des personnes en situation de détresse du fait de la guerre ou de toute autre cause de souffrance en leur redonnant dignité et sens à la vie ;</p>
                        <p class="description">	•	de développer la responsabilité du citoyen en s’appuyant sur des valeurs éthiques, notamment de justice, de respect de l’autre et d’intégrité ;</p>
                        <p class="description">	•	de renforcer d’une manière générale, la cohésion sociale dans toutes les sphères de la société au Mali et dans le monde.</p>

                        <p class="description"> Le siège social est à Kati Sananfara et peut être transféré en tout lieu sur l’étendue du territoire malien;</p>
                        <p class="description"> La zone d'intervention de l'association est l’étendue du territoire national.</p>
                    </tab-pane>

                    <tab-pane key="tab3">
                        <template slot="title">
                            <i class="ni ni-briefcase-24 mr-2"></i>Bureau
                        </template>

                        <p class="description">	•	Président</p>
                        <p class="description">	•	Vice -présidente</p>
                        <p class="description">	•	Le secrétaire</p>
                        <p class="description">	•	Le secrétaire adjoint</p>
                        <p class="description">	•	Trésorier</p>
                        <p class="description">	•	Trésorier adjoint</p>
                    </tab-pane>
                </card>
            </tabs>
        </div>
    </div>            
    </div>
    
</template>

<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
export default {
  name: "home",
  components: {
    Tabs,
    TabPane
  }
};
</script>
